import {I18nMessage} from "@shared/api/model/i18n";
import {TemplateRef} from '@angular/core';
import {IconProp} from "@fortawesome/fontawesome-svg-core";

/**
 * Indicates what Title should be set on the Browser Tab. When implementing this interface, the component can
 * dynamically change the value, and it will be propagated to the Browser Tab title.
 *
 * The setting the actual title of a browser tab is implemented by
 * {@link BrowserTabTitleActivatedRouteComponentsDirective}
 *
 * If the component wants to use Angular built-in router based way of setting titles:
 * {@link https://angular.io/api/router/Route#title}
 * do not implement this interface.
 */
export interface TitleProvider {
  getTitle(): I18nMessage | null;
}

/**
 * Use {@link TitleProvider} in most cases. Only use this interface if the returned title cannot be internationalised
 * (i.e. cannot be {@link I18nMessage} and has to be a string. For example, it is a name of a company that should not be
 * internationalised.
 */
export interface TitleStringProvider {
  getTitleStr(): string | null;
}


export function isTitleProvider(value: any): value is TitleProvider {
  return (typeof value?.getTitle === 'function');
}

export function isTitleStringProvider(value: any): value is TitleStringProvider {
  return (typeof value?.getTitleStr === 'function');
}

/**
 * Need to provide at least {@link onClick} or {@link routerLink} as otherwise the button will not do anything
 */
export interface HeaderButton {
  text: I18nMessage;
  title?: I18nMessage;
  icon?: {
    icon: IconProp;
    spin?: boolean;
  };
  onClick?: (event?: MouseEvent) => void;
  routerLink?: any[] | string;
  disabled?: boolean;
}

export interface HeaderButtonsProvider {
  getHeaderButtons(): HeaderButton[];
}

export function isHeaderButtonsProvider(value: any): value is HeaderButtonsProvider {
  return (typeof value?.getHeaderButtons === 'function');
}

export interface HeaderContentProvider {
  getHeaderContent(): TemplateRef<any> | null
}

export function isHeaderContentProvider(value: any): value is HeaderContentProvider {
  return (typeof value?.getHeaderContent === 'function');
}

